module.exports = __webpack_public_path__ + "4df636a64207aa60a620a692b1b88084.svg";